import { h, Component } from 'preact';
import { Router } from 'preact-router';

import Header from './header';
import Footer from './footer';

// Code-splitting is automated for routes
import Home from 'routes/home';
import Contact from 'routes/contact';
import GeneralTerms from 'routes/terms';
import PrivacyTerms from 'routes/privacy';
import DeliveryTerms from 'routes/deliveryterms';
import Checkout from 'routes/checkout';
import Confirmation from 'routes/confirmation';
import Ticket from 'routes/ticket';
import Receipt from 'routes/receipt';
import Event from 'routes/event';
import Profile from 'routes/profile';
import Orders from 'routes/orders';
import Payment from 'routes/payment';

import CartProvider from 'components/cart';
import AuthProvider from 'components/auth';

export default class App extends Component {
	state = {
		url: window.location.pathname
	}
	handleRoute = e => {
		const {url} = e;
		this.setState({url});
		window.scrollTo(0, 0);

	}

	getChildContext(){
		return {
			cart: [],
			categories: ['Musiikki','Urheilu','Muut']
		}
	}

	render(props,{url}) {
		return (
			<CartProvider>
				<AuthProvider>
					<div id="app">
						{url.indexOf('receipt') === -1 ? <Header />: null}
						<Router onChange={this.handleRoute}>
							<Home path="/" />
							<Contact path="/ota-yhteytta" />
							<Home path="/tapahtumat" />
							<Event path="/tapahtumat/:slug/:id" />

							<Profile path="/profiili" />
							<Orders path="/profiili/liput" />

							<Checkout path="/ostoskori" />
							<Payment path="/ostoskori/:cart" />

							<Confirmation path="/tilaus/:cart" />
							<Receipt path="/kuitti/:cart" />
							<Ticket path="/lippu/:ticket" />

							<GeneralTerms path="/kayttoehdot" />
							<PrivacyTerms path="/tietosuojalauseke" />
							<DeliveryTerms path="/toimitusehdot" />

						</Router>
						{url.indexOf('receipt') === -1 ? <Footer />: null}
					</div>
				</AuthProvider>
			</CartProvider>
		);
	}
}



// WEBPACK FOOTER //
// ./components/app.js